import { render } from "./PreAuthsDetails.vue?vue&type=template&id=0065bc7a&scoped=true"
import script from "./PreAuthsDetails.vue?vue&type=script&lang=js"
export * from "./PreAuthsDetails.vue?vue&type=script&lang=js"

import "./PreAuthsDetails.vue?vue&type=style&index=0&id=0065bc7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0065bc7a"]])

export default __exports__